package com.macrofocus.nastac.ui.layer.legacy

import deckgl.MVTLayer
import js.objects.unsafeJso

fun createRailwayLayer(year: Int): MVTLayer<Any> {
    val rshapes = MVTLayer<Any>(unsafeJso {
        id = "rshapes-$year"
        this.data = "/martin/rshapes/${year}"

        this.pickable = false
        asDynamic().stroked = true
        asDynamic().filled = false
        asDynamic().extruded = false
        asDynamic().pointType = "circle"
//        lineWidthScale = 20
        asDynamic().lineWidthMinPixels = 2
        asDynamic().lineWidthMaxPixels = 4
        asDynamic().getFillColor = null
        asDynamic().getLineColor = { d : dynamic ->
            val year = (d.properties.year as Number).toInt()
            if(year >= 1920) arrayOf(245,219,76)
            else if(year >= 1910) arrayOf(252,159,13)
            else if(year >= 1900) arrayOf(245,122,24)
            else if(year >= 1890) arrayOf(223,83,55)
            else if(year >= 1880) arrayOf(189,56,83)
            else if(year >= 1870) arrayOf(149,38,103)
            else if(year >= 1860) arrayOf(108,24,110)
            else if(year >= 1850) arrayOf(67,10,104)
            else if(year >= 1840) arrayOf(24,12,59)
            else if(year >= 1830) arrayOf(0,0,4)
            else arrayOf(0,0,0)
        }
        asDynamic().getPointRadius = 100
        asDynamic().getLineWidth = 5000
        asDynamic().getElevation = 30

        asDynamic().pickable = true

//        asDynamic().onOver = { info: dynamic ->
//            println("onOver: $info")
//        }
    })
    return rshapes
}